// extracted by mini-css-extract-plugin
export default {"grid":"jobAdvertGrid_grid__vJ7M-","noResults":"jobAdvertGrid_noResults__AS3x7"};